import { render, staticRenderFns } from "./ArcadeRoadmap.vue?vue&type=template&id=5d1b307a&"
import script from "./ArcadeRoadmap.vue?vue&type=script&lang=js&"
export * from "./ArcadeRoadmap.vue?vue&type=script&lang=js&"
import style0 from "./ArcadeRoadmap.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports